<form name="limitForm" [formGroup]="limitForm" novalidate>
  <div class="form-group uk-form-controls">
    <label class="uk-form-label" for="">Monatliches Limit (max. 1000 €)</label>
    <input
      type="number"
      name="limit"
      id="limit"
      placeholder="Monatliches Limit (max. 1000 €)"
      formControlName="limit"
      step="1"
      max="1000"
      class="uk-width-medium uk-input"
      min="1"
      onkeydown="if(event.key==='.' || event.key===','){event.preventDefault();}"
      (blur)="preventDecimals($event.target.value)"
    />
    <div
      class="co-form-error"
      *ngIf="
        (limitForm.get('limit').hasError('min') ||
          limitForm.get('limit').hasError('max')) &&
        limitForm.get('limit').touched
      "
    >
      <span class="uk-margin-small-right uk-text-danger" uk-icon="info"></span>
      Bitte geben Sie einen Wert zwischen 1 und 1.000€ an.
    </div>
  </div>
  <p class="info">
    Der Glücksspielstaatsvertrag verpflichtet uns, Ihnen die Einrichtung eines
    monatlichen Spiellimits zu ermöglichen. Falls Sie dies wünschen, geben Sie
    bitte Ihr monatliches persönliches Spiellimit ein.
  </p>
</form>
